import styleToCss from 'style-object-to-css-string';
import WebFont from 'webfont';
export default class {
  constructor() {
    this.stylesheet = this.createStylesheet();
  }

  static addLink(path) {
    const el = document.createElement('link');
    el.href = path;
    el.rel = 'stylesheet';
    el.type = 'text/css';
    document.getElementsByTagName('head')[0].appendChild(el);
  }

  createStylesheet() {
    const el = document.createElement('style');
    el.id = 'cc_theme';
    el.type = 'text/css';
    document.getElementsByTagName('head')[0].appendChild(el);
    let sheet;
    for (let i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].disabled) {
        continue;
      }
      sheet = document.styleSheets[i];
    }
    return sheet;
  }

  addRules(config) {
    this.addRule('#app .button', config.accent);
    this.addRule('#app .survey .column:first-child', config.secondary);
    this.addRule('a:link, a:visited', { color: config.primary.color });
    this.addRule('.theme-secondary', config.secondary);
    this.addRule('.theme-primary', config.primary);
    this.addRule('.theme-accent', config.accent);
  }

  addFonts(config) {
    try {
      const families = [config.fonts.heading, config.fonts.copy];
      WebFont.load({
        google: {
          families: families,
        },
      });
      this.addRule('body', {
        fontFamily: config.fonts.copy,
        fontSiez: config.fonts.size,
      });
      this.addRule('h1, h2, h3, h4, h5', { fontFamily: config.fonts.heading });
    } catch (e) {
      // throw new Error('Could not add fonts from config')
    }
  }

  addRule(selector, rules) {
    const idx = this.stylesheet.cssRules ? this.stylesheet.cssRules.length : 0;
    this.stylesheet.insertRule(selector + ' {' + styleToCss(rules) + '}', idx);
  }
}
